<label>{{ filter.label }}</label>
<div class="d-inline-flex">
  <select (ngModelChange)="filterChange.emit(filter)" [(ngModel)]="filter.operator" class="form-control">
    <option value="equals">égal(e) à</option>
    <option value="greaterThan">supérieur(e) à</option>
    <option value="lessThan">inférieur(e) à</option>
    <option value="between">entre ... et ...</option>
  </select>
  <div class="ml-2">
    <input [id]="filter.attribute" [name]="filter.attribute" (ngModelChange)="filterChange.emit(filter)" [(ngModel)]="filter.tempValue" class="form-control" type="number" />
  </div>
  <div *ngIf="filter.operator === 'between'" class="ml-2">
    <input (ngModelChange)="filterChange.emit(filter)" [(ngModel)]="filter.tempSecondValue" class="form-control" type="number" />
  </div>
</div>
